var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-columns",
    {
      scopedSlots: _vm._u([
        {
          key: "rightColumn",
          fn: function() {
            return [_c("notifications")]
          },
          proxy: true
        }
      ])
    },
    [
      _c("v-data-table", {
        staticClass: "border-a pa-6 row-pointer rounded",
        attrs: {
          headers: _vm.generateHeaders(_vm.tableConfig),
          items: _vm.$store.getters["license/licenses"],
          options: _vm.groupOptions,
          "server-items-length": _vm.$store.getters["license/totalItems"],
          "item-key": "key",
          loading: _vm.$store.getters["license/loading"],
          "loading-text": _vm.$t("common.loading"),
          "footer-props": _vm.$store.getters["license/footerProps"],
          "multi-sort": "",
          "mobile-breakpoint": "0"
        },
        on: {
          "update:options": function($event) {
            _vm.groupOptions = $event
          },
          "click:row": function(item) {
            return _vm.$router.push(
              "/licenses/" + item.key + "?preserveQuery=true"
            )
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "va-table-top",
                  {
                    attrs: {
                      title: _vm.$t("licensesList.title"),
                      cta: _vm.$t("common.license")
                    },
                    on: {
                      ctaClick: function($event) {
                        _vm.dialog = true
                      }
                    },
                    model: {
                      value: _vm.searchString,
                      callback: function($$v) {
                        _vm.searchString = $$v
                      },
                      expression: "searchString"
                    }
                  },
                  [
                    _c("va-switch", {
                      staticClass: "mt-1 mr-5",
                      attrs: { text: _vm.$t("licensesList.includeTrials") },
                      model: {
                        value: _vm.includeTrials,
                        callback: function($$v) {
                          _vm.includeTrials = $$v
                        },
                        expression: "includeTrials"
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "no-data",
            fn: function() {
              return [_c("va-no-data-tag")]
            },
            proxy: true
          },
          {
            key: "header.isTrial",
            fn: function() {
              return [
                _c("v-select", {
                  attrs: {
                    dense: "",
                    "single-line": "",
                    items: _vm.trialOptions,
                    label: _vm.$t("common.trial"),
                    "item-text": "label",
                    "item-value": "id",
                    clearable: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("va-badge", {
                            attrs: { text: item.label, size: "xs" }
                          })
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.filterTrial,
                    callback: function($$v) {
                      _vm.filterTrial = $$v
                    },
                    expression: "filterTrial"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "item.key",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", { staticClass: "py-1" }, [
                  _c("strong", { staticClass: "d-block" }, [
                    _vm._v(_vm._s(item.key))
                  ]),
                  _c("span", { staticClass: "d-block text-caption" }, [
                    _vm._v(_vm._s(item.name))
                  ]),
                  _c("span", { staticClass: "d-block text-caption" }, [
                    _vm._v(" " + _vm._s(item.sku) + " ")
                  ])
                ])
              ]
            }
          },
          {
            key: "item.type",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(" " + _vm._s(item.isPod ? "Room" : "Enterprise") + " ")
              ]
            }
          },
          {
            key: "item.activations",
            fn: function(ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " +
                    _vm._s(item.activations.current) +
                    " / " +
                    _vm._s(item.activations.max) +
                    " "
                )
              ]
            }
          },
          {
            key: "item.expirationDate",
            fn: function(ref) {
              var item = ref.item
              return [
                item.licenseIsPerpetual
                  ? _c("va-badge", {
                      attrs: {
                        size: "s",
                        text: _vm.$t("licensesList.perpetual"),
                        color: "success"
                      }
                    })
                  : _c("span", [
                      _vm._v(_vm._s(_vm._f("date2string")(item.expirationDate)))
                    ])
              ]
            }
          },
          {
            key: "item.maintenanceExpirationDate",
            fn: function(ref) {
              var item = ref.item
              return [
                item.maintenanceIsPerpetual
                  ? _c("va-badge", {
                      attrs: {
                        size: "s",
                        text: _vm.$t("licensesList.perpetual"),
                        color: "success"
                      }
                    })
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("date2string")(item.maintenanceExpirationDate)
                        )
                      )
                    ])
              ]
            }
          },
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("va-badge", {
                  attrs: {
                    size: "s",
                    text: item.status,
                    color: _vm.statusColor(item)
                  }
                })
              ]
            }
          },
          {
            key: "item.name",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("va-badge", {
                  attrs: {
                    size: "s",
                    text: item.status,
                    color: _vm.statusColor(item)
                  }
                })
              ]
            }
          },
          {
            key: "item.isTrial",
            fn: function(ref) {
              var item = ref.item
              return [
                item.isTrial
                  ? _c("span", { staticClass: "orange--text" }, [
                      _vm._v(_vm._s(_vm.$t("common.trial")))
                    ])
                  : _c("span", {}, [_vm._v(_vm._s(_vm.$t("common.regular")))])
              ]
            }
          },
          {
            key: "item.actions",
            fn: function() {
              return [_c("va-details-button")]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "card", width: "700", scrollable: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("new-license-form", {
            on: {
              onDismiss: function($event) {
                _vm.dialog = false
              },
              onFinish: function($event) {
                _vm.dialog = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }